import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { ImageWithIconFallback } from '@skytech/ui/Image'
import ImageOffOutlineIcon from 'mdi-react/ImageOffOutlineIcon'
import { useSelector } from 'react-redux'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { getSettings } from '@/ducks/devicePolicyReducer'

import { Translation } from '../i18n/Translation'

import type { Settings, Inventory } from './types'

import './style/inventory-device.scss'

function isNumber(x: unknown): x is number {
  return typeof x === 'number'
}

const InventoryDevice: FC<{
  models: Record<string, Inventory>
  item: string
  onDeviceSelect: (device: string) => void
}> = ({ models, item, onDeviceSelect }) => {
  const settings: Settings = useSelector(getSettings)
  const model = models[item][0]

  const getLowestPrice = () => {
    let lowestPrice: null | number = null

    const currentModels = models[item]

    currentModels.forEach(model => {
      if (lowestPrice === null || lowestPrice > model.price) lowestPrice = model.price
    })

    // Typescript fix for the current logic
    if (!isNumber(lowestPrice)) lowestPrice = 0

    lowestPrice -= settings.coveredAmount || 0
    return lowestPrice < 0 ? 0 : lowestPrice
  }

  const getImage = () => {
    const localImgUrl = './images/' + item.replace(/ /g, '').replace('+', 'Plus') + '.png'
    return model.imgUrl ? model.imgUrl : localImgUrl
  }

  if (model.type !== 'MOBILE_PHONE') return null

  return (
    <div
      role="button"
      tabIndex={0}
      className="device"
      onKeyDown={() => onDeviceSelect(item)}
      onClick={() => onDeviceSelect(item)}
    >
      <div className="header">{item}</div>

      <div className="device-img-container">
        <ImageWithIconFallback src={getImage()} alt={item} fallbackIcon={<ImageOffOutlineIcon />} />
      </div>

      <Button variant="primary" size="medium">
        <Translation id="Fra" />{' '}
        <FormattedNumberWithCurrency amount={getLowestPrice()} className="ml-1" />
      </Button>
    </div>
  )
}

export default InventoryDevice
